/* nc-linesave */
!function(){
  var css="#cart .nc-lsave,body.template-cart .nc-lsave{display:flex;flex-wrap:nowrap;align-items:baseline;gap:6px;margin:0 0 7px;font-size:13px;line-height:1.3;font-weight:600;white-space:nowrap}"
    +"#cart .nc-lsave .nc-lsave-was,body.template-cart .nc-lsave .nc-lsave-was{color:#9aa7ac;text-decoration:line-through;font-weight:600}"
    +"#cart .nc-lsave .nc-lsave-now,body.template-cart .nc-lsave .nc-lsave-now{color:#0F2A33;font-weight:800;font-size:15px}"
    +"#cart .nc-lsave .nc-lsave-off,body.template-cart .nc-lsave .nc-lsave-off{color:#fff;background:linear-gradient(120deg,#C85C22,#E8935A);font-weight:800;font-size:11px;padding:2px 8px;border-radius:20px;letter-spacing:.02em}"
    +"#cart .pg-save-chip,body.template-cart .pg-save-chip{position:absolute !important;visibility:hidden !important;opacity:0 !important;pointer-events:none !important}"
    +"#cart li:not(.pg-free-line) .pg-free-note,body.template-cart li:not(.pg-free-line) .pg-free-note{display:none !important}";
  var st=document.createElement('style');st.textContent=css;(document.head||document.documentElement).appendChild(st);
  function money(c){try{return (window.Shopify&&Shopify.formatMoney)?Shopify.formatMoney(c):'$'+(c/100).toFixed(2)}catch(e){return '$'+(c/100).toFixed(2)}}
  var busy=false;
  /* ROWS ARE MATCHED BY LINE KEY, NOT BY POSITION.

     This paired lis[i] with cart.items[i]. Rendered order is not cart order:
     pg-chips' liftFree() moves every free row to the top of the drawer, and a
     line swapped by the size picker is removed and re-added so it comes back
     at the END of the cart. Either one slides the two lists apart, and then
     each row is handed its neighbour's item.

     That is not just wrong numbers. The else-branch below DELETES .nc-lsave
     from any row whose item shows no discount, so a console paired with the
     free case's item lost its price block outright and the theme's own price
     node showed through instead -- a different face, unbolded, beside a
     neighbour still in Poppins 800. That is the "font gets unbolded on one"
     report, and it flickered because the pairing changed on every render.

     Every row prints its own remove link, /cart/change?id=<variant>:<key>, and
     that key is exactly cart item .key. Index stays as the fallback for a row
     that has no remove link yet. */
  function keyOf(li){
    var a=li.querySelector('a[href*="/cart/change"]');
    if(!a)return '';
    var m=(a.getAttribute('href')||'').match(/[?&]id=([^&]+)/);
    return m?decodeURIComponent(m[1]):'';
  }
  /* THE ORDER-LEVEL PERCENTAGE, RE-FLOORED ON EACH LINE'S OWN FIGURE.
     Returns {lineKey: chargedCents} for every line whose allocations are
     readable and carry exactly one order-level percentage; any other line is
     absent from the map and prints Shopify's own allocation. */
  function perLine(cart){
    var out={},rate=0,orderApps=0,okCart=true;
    (cart.cart_level_discount_applications||[]).forEach(function(d){
      if(!d||d.target_selection!=='all')return;
      if(d.value_type!=='percentage'){okCart=false;return;}
      var r=parseFloat(d.value||0)/100;
      if(!(r>0&&r<1)){okCart=false;return;}
      rate=r;orderApps++;
    });
    if(!okCart||orderApps!==1)return out;
    (cart.items||[]).forEach(function(x){
      if(!x||!x.key)return;
      var orig=x.original_line_price||0;
      if(!(orig>0))return;
      var prod=0,ok=true;
      (x.line_level_discount_allocations||[]).forEach(function(a){
        var d=a&&a.discount_application;
        if(!d){ok=false;return;}
        if(d.target_selection==='all')return;   /* the order-level one, if a line ever lists it: re-floored below, not summed */
        prod+=(a.amount||0);
      });
      if(!ok)return;
      var after=orig-prod;
      if(after<0)return;
      /* THE 5% IS NOT TAKEN OFF THE LINE ANY MORE (2026-09-19 evening, owner:
         "keep the original prices in the cart without 5% off, then just take
         5% off ... like it already has"): the row prints the product-discounted
         figure and the totals box's "Extra 5% Off" row carries the 5% */
      out[x.key]=after;
    });
    return out;
  }
  function apply(cart){
    var byKey={};
    (cart.items||[]).forEach(function(x){ if(x&&x.key) byKey[x.key]=x; });
    var even={};
    try{even=perLine(cart);}catch(e){}
    var uls=document.querySelectorAll('.l4ca:not(.in-panel)');
    uls.forEach(function(ul){
      var lis=ul.querySelectorAll(':scope > li');
      for(var i=0;i<lis.length;i++){
        var li=lis[i];
        var k=keyOf(li);
        var it=(k&&byKey[k])||(k?null:cart.items[i]);
        if(!it)continue;
        var host=li.querySelector('section')||li;
        var existing=host.querySelector(':scope > .nc-lsave');
        var saved=it.total_discount||0;
        var orig=it.original_line_price||0;
        if(saved>0&&orig>0){
          var now=orig-saved;
          if(it.key&&even[it.key]!=null)now=even[it.key];
          var key=orig+'_'+saved+'_'+now;
          if(existing&&existing.getAttribute('data-k')===key)continue;
          var pct=Math.round((orig-now)/orig*100);
          var html='<span class="nc-lsave-was">'+money(orig)+'</span><span class="nc-lsave-now">'+money(now)+'</span><span class="nc-lsave-off">Save '+pct+'%</span>';
          if(existing){existing.innerHTML=html;existing.setAttribute('data-k',key);}
          else{var d=document.createElement('div');d.className='nc-lsave';d.setAttribute('data-k',key);d.innerHTML=html;host.insertBefore(d,host.firstChild);}
        }else if(existing&&existing.getAttribute('data-k')){existing.parentNode.removeChild(existing);}
      }
    });
  }
  /* THE PRICE USED TO PAINT TWICE, AND THE SECOND ONE WAS SMALLER.

     This block is not server-rendered: the theme prints its own price markup,
     and apply() replaces it with .nc-lsave (was 11.5px / now 15px / SAVE chip).
     The drawer is rebuilt wholesale on every cart change, so every change threw
     the .nc-lsave block away -- and getting it back meant waiting out
     `setTimeout(run,140)` AND a /cart.js round trip before a single pixel could
     change. For that whole window the shopper is looking at the theme's raw
     price at its own larger size; then it is replaced and everything below it
     moves. That is "the price text gets bigger" and a good part of "the words
     glitch up and down" -- on the free case most of all, since pg-case-mobile
     rewrites .nc-lsave-now to $0.00 and that cannot happen until this has run.

     The cart contents do not change during a re-render, so the last reading is
     still true: it is kept and repainted SYNCHRONOUSLY when the drawer mutates,
     which puts the final markup in the same frame as the swap. The fetch still
     follows, as the authority, for the case where the contents really did
     change. apply() is keyed on data-k and skips anything already correct, so
     the second pass is a no-op when it agrees.

     pg-drawer fires pg:cart-updated in the same task as its swap; listening for
     it as well means the repaint does not depend on observer timing. */
  var LAST=null,painting=false;
  function paintNow(){
    if(painting||!LAST)return;
    painting=true;
    try{apply(LAST);}catch(e){}
    /* released after the current task: apply() writes to the DOM and would
       otherwise wake the observer that called us */
    setTimeout(function(){painting=false;},0);
  }
  function run(){
    if(busy)return;
    if(!document.querySelector('.l4ca:not(.in-panel)'))return;
    busy=true;
    fetch('/cart.js').then(function(r){return r.json()}).then(function(cart){
      if(cart&&cart.items){LAST=cart;try{apply(cart);}catch(e){}}
      busy=false;
    }).catch(function(){busy=false;});
  }
  var c=document.getElementById('cart');
  if(c){try{new MutationObserver(function(){paintNow();setTimeout(run,140)}).observe(c,{childList:true,subtree:true});}catch(e){}}
  document.addEventListener('pg:cart-updated',function(){paintNow();setTimeout(run,60);});
  if(window.openPanel){var o=window.openPanel;window.openPanel=function(){var r=o.apply(this,arguments);setTimeout(run,280);setTimeout(run,850);return r};}
  if(document.readyState!=='loading')run();else document.addEventListener('DOMContentLoaded',run);
  setTimeout(run,1200);setTimeout(run,2600);
}();
